import {Component, OnInit, Input, AfterViewInit, NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import { Store } from '../store';
import {StoreService} from '../store.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { AppLogComponent } from '../../../../components/app-log/app-log.component'
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {RecordDataComponent} from "../../../../components/record-data";
import {Http} from "@angular/http";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {AppArcComponent} from "../../../../components/app-arc";
import {YearsShowComponent} from "../../years/years-show/years-show.component";
import {BranchService} from "../../branches/branch.service";
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";

@NgModule({
    imports: [CommonModule, FormsModule, DropdownModule,MessagesModule,MyInputsModule,
        ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
    ],
    declarations: [
        StoresShowComponent
    ],
    entryComponents: [
        StoresShowComponent
    ],
    exports: [],
    providers: [SharedService, StoreService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
  selector: 'app-stores-show',
  templateUrl: './stores-show.component.html',
  styleUrls: ['./stores-show.component.scss'],
  providers: [StoreService, ConfirmationService , MessageService]
})

export class StoresShowComponent implements OnInit , AfterViewInit {
  id: string;
  store = new Store();
  applog: AppLogComponent;
  @Input() delId;
  @Input() scrId;
  @Input() oldData;
  @Input() newData;
  @Input() modelName;
  @Input() newDatad;
  @Input() newDatap;
  statusVal = [{'val':1,'title':'Active'},{'val':2,'title':'Inactive'}];

  form: FormGroup;
  private sub: any;
  msgs: Message[] = [];
  allbranches: any[] = [];
  branches_enhance: any[] = [];
  branches: any[] = [];
  private _editButton: any;
  private _deleteButton: any;
  private _newButton: any;
  private _printButton: any;
  private _searchButton: any;
  public userRoles: any[]=[];
  public systemName = '';

  constructor(private route: ActivatedRoute,
              private router: Router,
              private sharedservice: SharedService,
              private storeService: StoreService,
              public activeModal: NgbActiveModal,
              public translate: TranslateService,
              private branchService: BranchService,
              private modalService: NgbModal,
              private confirmationService: ConfirmationService,
              private messageService: MessageService) {
    this.sharedservice.setTitle(this.route.snapshot.data.title);
    this.sharedservice.setItemShow(StoresShowComponent);
    this.sharedservice.setButtons([
        { label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton' },
        { label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton' },
        // { label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton' },
        { label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton' },
        { label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton' },
    ]);
    this.sharedservice.setModelName('stores');
    this.router.routeReuseStrategy.shouldReuseRoute = function(){
      return false;
    };

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.router.navigated = false;
        window.scrollTo(0, 0);
      }
    });
    }
  ngAfterViewInit(){
    if(!this.scrId && !this.oldData) {
      this._editButton = document.getElementById('editButton');
      this._deleteButton = document.getElementById('deleteButton');
      this._newButton = document.getElementById('newButton');
      this._printButton = document.getElementById('printButton');
      this._searchButton = document.getElementById('searchButton');

      if (this._editButton) {
        this._editButton.onclick = ((e: any) => {
          e.preventDefault();
          this.router.navigate(['/stores/edit', this.id]);
        });
      }
      if (this._deleteButton) {
        this._deleteButton.onclick = ((e: any) => {
          e.preventDefault();
          this.deleteStore(this.store);
        });
      }
      if (this._newButton) {
        this._newButton.onclick = ((e: any) => {
          e.preventDefault();
          this.router.navigate(['/stores']);
        });
      }

      if (this._searchButton) {
        this._searchButton.onclick = ((e: any) => {
          e.preventDefault();
          this.router.navigate(['/stores/search']);
        });

      }
    }

  }
    recordData() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                // this.changePicUrl();
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.store;
        modalRef.componentInstance.rowId = '';

    }
  ngOnInit() {

    const userdata = JSON.parse(localStorage.getItem('currentUser'));
    if (userdata) {
      this.userRoles = userdata.roles.description;
      // console.log(this.userRoles);
      this.systemName = userdata.systems[0];

    }
    this.router.routeReuseStrategy.shouldReuseRoute = function(){
      return false;
    };

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.router.navigated = false;
        window.scrollTo(0, 0);
      }
    });

    this.branchService.getAllBranches().subscribe(
      allbranches => {
        this.branches = allbranches.brancheslist;

      });
    this.sub = this.route.params.subscribe(params => {
      this.id = params['id'];
    });

    this.form = new FormGroup({
      id: new FormControl({value:'', disabled: true}),
      name: new FormControl({value:'', disabled: true}),
      status: new FormControl({value:'', disabled: true}),
      branch_id: new FormControl({value: '', disabled: true}),

    });

    if(this.id) {
      this.activeModal.dismiss('');
      this.oldData = false;
      this.newData = false;
      this.newDatap = true;
      this.delId = false;
      localStorage.removeItem('filter');
      const msg = JSON.parse(localStorage.getItem('showMessages'));
      if(msg) {
        localStorage.removeItem('showMessages');
        this.msgs = msg;
        this.msgs = [];
      }
      this.storeService.getById(this.id).subscribe(
        store => {
          this.id = store.id;
          this.store = store;
          this.form.patchValue({
            id: store.id,
            name: store.name,
            status: store.status,
            branch_id: store.branch_id,
          });
        }, error => {
          console.log(error);
        }
      );


    }
    if(this.delId) {
      this.oldData = false;
      this.newData = false;
      this.newDatap = !this.newDatap ;
      this.storeService.getTrashedById(this.delId).subscribe(
        store => {
          this.id = store.id;
          this.store = store;
          this.form.patchValue({
            id: store.id,
            name: store.name,
            status: store.status,
            branch_id: store.branch_id,
          });
        }, error => {
          console.log(error);
        }
      );
    }

    if(this.oldData && this.newData) {
        this.store = this.newData;
      this.form.patchValue({
        id: this.newData.id,
        name: this.newData.name,
        status: this.newData.status,
        branch_id: this.newData.branch_id,
      });
    }
  }
    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if(userRoles.indexOf('setting.stores.'+role) >= 0) {
            return true;
        }
        return false;
    }
  deleteStore(store: Store) {
    this.confirmationService.confirm({
      header: this.translate.instant('Confirm Delete'),
      message: this.translate.instant('Are you sure of delete ?'),
      icon: 'fa fa-trash',
      accept: () => {
        if (store) {
          this.storeService.delete(store.id).subscribe(
            res => {
              this.msgs = [];
              this.msgs.push({severity: 'success', summary: '', detail: this.translate.instant('Delete completed')});
              setTimeout(()=>{
              this.router.navigate(['/stores']);
            },1000);
                localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                window.scroll(0,0);
            }
          );
        }
      }
    });
  }

  recoverEdit(store: Store) {
    this.confirmationService.confirm({
      header: this.translate.instant('Confirm Undo Edit'),
      message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
      icon: 'fa fa-undo',
      accept: () => {
        if (store) {
          this.storeService.update(store).subscribe(
            res => {
              this.msgs = [];
              this.msgs.push({severity: 'success', summary: '', detail: this.translate.instant('Data returned')});
              this.activeModal.close('done');
              this.router.navigate(['/stores/show',store.id]);
            }
          );
        }
      }
    });

    this.router.routeReuseStrategy.shouldReuseRoute = function(){
      return false;
    };

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.router.navigated = false;
        window.scrollTo(0, 0);
      }
    });
  }

  undotrashed() {
    this.confirmationService.confirm({
      header: this.translate.instant('Confirm Undo Delete'),
      message: this.translate.instant('Are you sure about recover deleted item?'),
      icon: 'fa fa-undo',
      accept: () => {
        if (this.delId) {
          this.storeService.restoreTrashedById(this.delId).subscribe(
            res => {
              this.msgs = [];
              this.msgs.push({severity: 'success', summary: '', detail: this.translate.instant('Deleted item recovered')});
              this.activeModal.dismiss('close click');
              this.router.navigate(['/stores/list']);
            }
          );
        }
      }
    });
  }



  showattachement(row_id: string) {
    console.log(row_id)
    if (row_id) {
      const options: NgbModalOptions = {

        beforeDismiss: () => {
          // this.changePicUrl();
          return true;
        }
      };
      const modalRef = this.modalService.open(AppArcComponent, options);
      modalRef.componentInstance.rowId = row_id;
      modalRef.componentInstance.screenName = this.modelName;
    }
  }
  showHistory(row_id: string) {
    if (row_id) {
      const modalRef = this.modalService.open(AppLogComponent);
      modalRef.componentInstance.rowId = row_id;
        modalRef.componentInstance.refShow = StoresShowComponent;

    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/setting/stores/stores-show/stores-show.component.ts